import clsx from 'clsx'

import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'

import s from './styles.module.scss'

type StatusTheme = 'pending' | 'success' | 'danger'

export interface BookingStatusDialogItemView {
  icon: AllIcons
  text: string
}

interface BookingStatusDialogContentProps {
  title: string
  theme: StatusTheme
  items: BookingStatusDialogItemView[]
}

export const BookingStatusDialogContent = ({
  title,
  theme,
  items,
}: BookingStatusDialogContentProps) => {
  return (
    <div className={s.container}>
      <div className={s.titleWrapper}>
        <h3 className={clsx('bold-22', s.title)}>{title}</h3>
        <div className={s.titleIconWrapper}>
          <AppIcon
            id={AllIcons.INFO_CIRCLE}
            width={24}
            height={24}
            className={clsx(s.titleIcon, s[theme])}
          />
        </div>
      </div>
      <ul className={s.list}>
        {items.map((item) => (
          <li
            key={`${item.icon}-${item.text}`}
            className={s.listItem}
          >
            <div className={s.iconWrapper}>
              <AppIcon
                id={item.icon}
                width={20}
                height={20}
                className={s.icon}
              />
            </div>
            <p className={clsx('medium-14', s.text)}>{item.text}</p>
          </li>
        ))}
      </ul>
    </div>
  )
}
